"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDnd = require("react-dnd");

var _commonReact = require("@devsta/common-react");

var _ShotImage = _interopRequireDefault(require("../components/ShotImage"));

var DRAG_TYPE = 'box';

function drop(_ref) {
  var onDrop = _ref.onDrop;
  return {
    onDrop: onDrop
  };
}

var dragHandlers = {
  drop: drop
};

function getDragConfig(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

var _default = (0, _reactDnd.DropTarget)(DRAG_TYPE, dragHandlers, getDragConfig)((0, _commonReact.withAssetSelector)(_ShotImage.default));

exports.default = _default;